import React, { useState, useEffect } from "react";
import {
  FaCopy,
  FaEdit,
  FaHeartbeat,
  FaListUl,
  FaLocationArrow,
  FaStethoscope,
  FaUsers,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Footer from "../../components/footer";
import EditClinicalSite from "../../components/Admin/EditClinicalSite";
import { GetClinicalSiteById } from "../../hooks/getClinicalSiteById";
import { getClinicalSiteStats } from "../../services/clinical_sites";

const ClinicalSiteHomepage = (props) => {
  const {
    data: clinicalSite,
    isLoading,
    error,
  } = GetClinicalSiteById(props.match.params.id);

  const [stats, setStats] = useState(null);
  const [statsLoading, setStatsLoading] = useState(true);
  const [statsError, setStatsError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setStatsLoading(true);
        const clinicalSiteId = props.match.params.id;
        const response = await getClinicalSiteStats(clinicalSiteId);

        if (response.status === 200) {
          setStats(response.data);
        } else {
          setStatsError("Failed to fetch stats");
        }
      } catch (err) {
        setStatsError("Error fetching clinical site stats");
        console.error(err);
      } finally {
        setStatsLoading(false);
      }
    };

    if (props.match.params.id) {
      fetchStats();
    }
  }, [props.match.params.id]);

  return (
    <>
      <div className="container-fluid pt-12 pl-21 pb-12 pr-24 h-100">
        <div className="card border-0 h-100">
          <div className="card-body">
            <h5 className="font-weight-lighter">
              ADMIN: Clinical Site Home Page
            </h5>
            <hr />
            <div className="row my-1 h-100 pb-5">
              <div className="col-md-5">
                <div className="card border-0 shadow-lg h-100">
                  <div className="card-body h-100 d-flex flex-column justify-content-between">
                    <div>
                      <div className="text-center mt-3">
                        <img
                          // src={User}
                          width={300}
                          height={170}
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                      <h5 className="text-center my-4">
                        {clinicalSite?.data?.name}
                      </h5>
                      <div className="text-center small-text mb-4">
                        <p className="mb-1">
                          {clinicalSite?.data?.streetAddress}
                        </p>
                        <p className="mb-1">
                          {clinicalSite?.data?.city},{" "}
                          {clinicalSite?.data?.province}
                        </p>
                        <p className="mb-1">1K1H 7W9</p>
                        <p>{clinicalSite?.data?.country}</p>
                      </div>
                      <div className="text-center small-text">
                        <p>{clinicalSite?.data?.phoneNumber}</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <button
                        className="btn btn-outline-primary btn-edit-user-profile"
                        data-toggle="modal"
                        data-target="#editClinicalSite"
                      >
                        <FaEdit size={16} className="mr-2" /> Edit
                      </button>
                      <EditClinicalSite />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5 offset-md-1">
                <div className="d-flex h-74 border-primary rounded justify-content-center align-items-center text_default small-text my-3 rounded-15">
                  <div className="d-flex align-items-center">
                    <small className="text-right w-99">
                      Clinical Locations
                    </small>
                    <FaLocationArrow
                      size={16}
                      color="#353c51"
                      className="ml-3"
                    />
                  </div>
                  <div className="ml-32 border-primary rounded w-35 h-35 d-flex align-items-center justify-content-center">
                    {statsLoading ? (
                      <div className="bg-light rounded" style={{ width: 25, height: 14 }}></div>
                    ) : (
                      <small className="text_default">{stats?.clinicalLocations || 0}</small>
                    )}
                  </div>

                  <div className="ml-32 ">
                    <Link
                      to={"/hcp/patient/function_score"}
                      className="text_primary"
                    >
                      <i className="fa fa-chevron-right" />
                    </Link>
                  </div>
                </div>
                <div className="d-flex h-74 border-primary rounded justify-content-center align-items-center text_default small-text my-3 rounded-15">
                  <div className="d-flex align-items-center">
                    <small className="text-right w-99">Patients</small>
                    <FaHeartbeat size={16} color="#353c51" className="ml-3" />
                  </div>
                  <div className="ml-32 border-primary rounded w-35 h-35 d-flex align-items-center justify-content-center">
                    {statsLoading ? (
                      <div className="bg-light rounded" style={{ width: 25, height: 14 }}></div>
                    ) : (
                      <small className="text_default">{stats?.patients || 0}</small>
                    )}
                  </div>

                  <div className="ml-32 ">
                    <Link
                      to={"/hcp/patient/function_score"}
                      className="text_primary"
                    >
                      <i className="fa fa-chevron-right" />
                    </Link>
                  </div>
                </div>
                <div className="d-flex h-74 border-primary rounded justify-content-center align-items-center text_default small-text my-3 rounded-15">
                  <div className="d-flex align-items-center">
                    <small className="text-right w-99">Users</small>
                    <FaUsers size={16} color="#353c51" className="ml-3" />
                  </div>
                  <div className="ml-32 border-primary rounded w-35 h-35 d-flex align-items-center justify-content-center">
                    {statsLoading ? (
                      <div className="bg-light rounded" style={{ width: 25, height: 14 }}></div>
                    ) : (
                      <small className="text_default">{stats?.users || 0}</small>
                    )}
                  </div>

                  <div className="ml-32 ">
                    <Link
                      to={"/hcp/patient/function_score"}
                      className="text_primary"
                    >
                      <i className="fa fa-chevron-right" />
                    </Link>
                  </div>
                </div>
                <div className="d-flex h-74 border-primary rounded justify-content-center align-items-center text_default small-text my-3 rounded-15">
                  <div className="d-flex align-items-center">
                    <small className="text-right w-99">Positions</small>
                    <FaStethoscope size={16} color="#353c51" className="ml-3" />
                  </div>
                  <div className="ml-32 border-primary rounded w-35 h-35 d-flex align-items-center justify-content-center">
                    {statsLoading ? (
                      <div className="bg-light rounded" style={{ width: 25, height: 14 }}></div>
                    ) : (
                      <small className="text_default">{stats?.positions || 0}</small>
                    )}
                  </div>

                  <div className="ml-32 ">
                    <Link
                      to={"/hcp/patient/function_score"}
                      className="text_primary"
                    >
                      <i className="fa fa-chevron-right" />
                    </Link>
                  </div>
                </div>
                <div className="d-flex h-74 border-primary rounded justify-content-center align-items-center text_default small-text my-3 rounded-15">
                  <div className="d-flex align-items-center">
                    <small>Functional Checklists</small>
                    <FaListUl size={16} color="#353c51" className="ml-3" />
                  </div>
                  <div className="ml-2">
                    <div className="d-flex align-items-center">
                      <small>Generic</small>
                      <div className="ml-2 border-primary rounded w-34 h-34 d-flex align-items-center justify-content-center">
                        {statsLoading ? (
                          <div className="bg-light rounded" style={{ width: 20, height: 12 }}></div>
                        ) : (
                          <small className="text_default">{stats?.genericChecklists || 0}</small>
                        )}
                      </div>
                    </div>
                    <div className="mt d-flex align-items-center">
                      <small>Custom</small>
                      <div className="ml-2 border-primary rounded w-34 h-34 d-flex align-items-center justify-content-center">
                        {statsLoading ? (
                          <div className="bg-light rounded" style={{ width: 20, height: 12 }}></div>
                        ) : (
                          <small className="text_default">{stats?.customChecklists || 0}</small>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="ml-32 ">
                    <Link
                      to={"/hcp/patient/function_score"}
                      className="text_primary"
                    >
                      <i className="fa fa-chevron-right" />
                    </Link>
                  </div>
                </div>
                <div className="d-flex h-74 border-primary rounded justify-content-center align-items-center text_default small-text my-3 rounded-15">
                  <div className="d-flex align-items-center">
                    <small className="text-right w-99">Reports</small>
                    <FaCopy size={16} color="#353c51" className="ml-3" />
                  </div>
                  <div className="ml-32 border-primary rounded w-35 h-35 d-flex align-items-center justify-content-center">
                    <small className="text_default">8</small>
                  </div>

                  <div className="ml-32 ">
                    <Link
                      to={"/hcp/patient/function_score"}
                      className="text_primary"
                    >
                      <i className="fa fa-chevron-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ClinicalSiteHomepage;
